/**
 * WHERE THE DEPLOYED BACKEND LIVES. One value, in the repo, used by everything that needs it.
 *
 * This is the FALLBACK, not the override. REACT_APP_API_URL still wins when it is set to an
 * absolute URL, because that is how both deployment platforms configure this and both are set
 * correctly today. What this replaces is the old fallback of 'http://localhost:3001/api'.
 *
 * That mattered on 8/25/26. `.env` is gitignored, so a fresh clone has no REACT_APP_API_URL: a
 * production build made there asked the VISITOR'S OWN MACHINE for the API. It compiles and deploys
 * without complaint and fails as an unexplained "Network error" at the login screen. Only a value
 * typed into a hosting dashboard stood between that and production, and no checkout could see it.
 *
 * The value here is deliberately the same one the dashboards hold. It is not trying to win an
 * argument with them - it is what the app falls back to when nobody has told it anything, and a
 * developer's laptop is the wrong answer to that question.
 *
 * TO REPOINT A DEPLOYED APP, change REACT_APP_API_URL where it is deployed. Change this line too,
 * so the two do not drift.
 *
 * Plain CommonJS on purpose. src/setupProxy.js - the dev-server proxy, which needs the same
 * origin - is GITIGNORED, so it lives only on developer machines and is loaded by Node with no
 * Babel; an ESM export here would break `npm start` for anyone whose copy requires this file.
 * Webpack and jest both import it happily either way.
 */
const PRODUCTION_API_ORIGIN = 'https://medeffectbackend-809w.onrender.com';

module.exports = {
  PRODUCTION_API_ORIGIN,
  PRODUCTION_API_URL: `${PRODUCTION_API_ORIGIN}/api`,
};
